import { HelmetProvider, Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";

const PageMeta = ({
  description = "Alchely",
}: {
  title?: string;
  description?: string;
}) => {
  const { t } = useTranslation();

  return (
    <Helmet>
      <title>{t("common.pageTitle")}</title>
      <meta name="description" content={description} />
    </Helmet>
  );
};

export const AppWrapper = ({ children }: { children: React.ReactNode }) => (
  <HelmetProvider>{children}</HelmetProvider>
);

export default PageMeta;
